import axios from "axios";

const createSeqOthersJobs = async (SeqOthers) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/SeqOthersJobs`, SeqOthers)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getAllSeqOthersJobs = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/SeqOthersJobs`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getAllSeqOthersJobsStatus = async (status = "OPEN") => {
  const params = { job_status: status };
  return axios
    .get(`${process.env.REACT_APP_API_URL}/SeqOthersJobs/`, {params})
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getSeqOthersJobs = async (id) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/SeqOthersJobs/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const editSeqOthersJobs = async (id, SeqOthers) => {
  return axios
    .patch(`${process.env.REACT_APP_API_URL}/SeqOthersJobs/${id}`, SeqOthers)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const deleteSeqOthersJobs = async (id, force) => {
  return axios
    .delete(
      `${process.env.REACT_APP_API_URL}/SeqOthersJobs/${id}?force=${force}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const SeqOthersJobsService = {
  createSeqOthersJobs,
  getAllSeqOthersJobs,
  getAllSeqOthersJobsStatus,
  getSeqOthersJobs,
  editSeqOthersJobs,
  deleteSeqOthersJobs
};

export default SeqOthersJobsService;
